var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"f7",attrs:{"data-f7-icon":_vm.name,"aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }